const state = {
  navigationDirection: 'back',
  editMode: false,
  shopping: false
}

const mutations = {
  'SET_NAV_DIRECTION' (state, direction) {
    state.navigationDirection = direction
  },
  'TOGGLE_EDIT_MODE' (state) {
    state.editMode = !state.editMode
  },
  'TOGGLE_SHOPPING_MODE' (state, payload) {
    if (payload === false) state.shopping = payload
    else state.shopping = !state.shopping
  }
}

const actions = {

}

const getters = {
  getNavDirection: state => state.navigationDirection,
  getEditMode: state => state.editMode,
  getShoppingState: state => state.shopping
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/commonStore.js